import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=24f9237e&scoped=true"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=24f9237e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f9237e",
  null
  
)

export default component.exports